import Header from "@/components/Header";
import SEOHead from "@/components/SEOHead";
import Footer from "@/components/Footer";
import HeroSection from "@/components/home/HeroSection";
import QuoteSection from "@/components/home/QuoteSection";
import BuiltFastSection from "@/components/home/BuiltFastSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import ProcessSection from "@/components/home/ProcessSection";
import PerformanceSection from "@/components/home/PerformanceSection";
import MaintenanceSection from "@/components/home/MaintenanceSection";
import ProjectsSection from "@/components/home/ProjectsSection";
import FAQSection from "@/components/home/FAQSection";
import ContactCTASection from "@/components/home/ContactCTASection";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEOHead
        title="NETIUS — Web Development Agency in Orlando, FL"
        description="High-performance custom websites delivered in 3-7 days. Web development agency in Orlando, FL serving clients nationwide and worldwide."
        path="/"
      />
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-foreground text-background px-4 py-2 rounded-md z-50">
        Skip to main content
      </a>
      <Header />
      
      <main id="main-content" className="flex-1">
        <HeroSection />
        <QuoteSection />
        <BuiltFastSection />
        <FeaturesSection />
        <TestimonialsSection />
        <ProcessSection />
        <PerformanceSection />
        <MaintenanceSection />
        <ProjectsSection />
        <FAQSection />
        <ContactCTASection />
      </main>

      <Footer />
    </div>
  );
};

export default Index;
